export default __webpack_public_path__ + "static/media/SharpGroteskBook19.e51afd66.woff2";